export default "__VITE_ASSET__407c0f0f__"